import React, { Component } from "react";
import queryString from "query-string";
import _ from "lodash";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { faMapMarkedAlt } from "@fortawesome/pro-regular-svg-icons";

import Filters, { eGroupFiltersValues } from "./home/Filters";
import CampusFilter from "./home/CampusFilter";
import HomeSection from "./home/Section";
import GroupsList from "./home/GroupList";
import ConditionalWrapper from "../general/ConditionalWrapper";

import { eGroupRouteProps, Props } from "../propTypes";
import { ObjectLiteral } from "../../constants";
import { Campus } from "../../store/main/types";
import { eGroup, eGroupHome, eGroupFilter } from "../../store/egroups/types";
import { GroupListItemLoading } from "./home/GroupListItemLoading";

import Error404 from "../404";
import { Helpers } from "./common/helpers";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "../../store/mapProps";
import { NextRouter, withRouter } from "next/router";
import { ParsedUrlQuery } from "querystring";

type State = {
    expandedFilters: string[];

    blockedCampus: string[];

    isLoading: boolean;
    successTimestamp: number;
    eGroupsRaw: eGroup[];
    eGroupCount: number;
    isDemographicLoading: boolean;
    campuses: Campus[];
    description: string;
    title: string;

    isCampusesLoading: boolean;
    iseGroupTypesLoading: boolean;
    currentFilters: ObjectLiteral | null;
    filtersLoaded: boolean;
    showCampusFilter: boolean;
    homepageLoaded: boolean;
    eGroupHomeData: eGroupHome | undefined;
    window: {
        width: number;
        height: number;
    };
    eGroupFiltersValues: eGroupFiltersValues | null;
    eGroupFiltersValuesRaw: eGroupFilter[];
    show404: boolean;
    selectedFilters: ObjectLiteral[];
    currentCampus: string;
    isScollAfterHeader: boolean;
};

interface WithRouterProps {
    router: NextRouter;
}

// eGroups Home Component
/**
 * This component is used to display the eGroups Map and Campus select options for users
 * to search for and sign up for eGroups.
 *
 * The campus values are being pulled from this.props.actions.main.main_get_all_campuses().
 * Check this action and the api calls set up within them if you run into any problems.
 */

// class eGroupsHome extends React.Component<Props & WithRouterProps, State> {
class eGroupsHome extends Component<
    Props & WithRouterProps & eGroupRouteProps,
    State
> {
    readonly eGroupsRequestId = "eGroupList"; //unique ID to handle the eGroups call
    readonly eGroupListPaginationRequestId = "eGroupListPagination";
    readonly eGroupToShow: string =
        process.env.NEXT_PUBLIC_EGROUP_COUNT || "10";
    readonly eGroupPaginationQuery = {
        limit: this.eGroupToShow,
    };
    readonly eGroupGlobalPaginationQuery = {
        recordType: "Youth",
    };

    eGroupBaseUrl = "/egroups";

    helpers = new Helpers();

    pageRef = React.createRef<HTMLDivElement>();
    childRef = React.createRef<HTMLDivElement>();

    state: State = {
        expandedFilters: [],
        blockedCampus: [],
        isLoading: true,
        successTimestamp: -1,
        eGroupsRaw: [],
        eGroupCount: -1,
        isDemographicLoading: false,
        campuses: [],
        description: "",
        title: "",
        isCampusesLoading: false,
        iseGroupTypesLoading: false,
        currentFilters: null,
        filtersLoaded: false,
        showCampusFilter: false,
        homepageLoaded: false,
        eGroupHomeData: undefined,
        eGroupFiltersValues: null,
        eGroupFiltersValuesRaw: [],
        show404: false,
        window: {
            width: 0,
            height: 0,
        },
        selectedFilters: [],
        currentCampus: this.props.selectedCampusSlug,
        isScollAfterHeader: false,
    };

    // Component Did Mount Lifecycle Method
    /**
     * componentDidMount() runs immediately after the component mounts.
     */
    componentDidMount() {
        // this.eGroupBaseUrl = this.props.match.path.replace("/:campus?", ""); //remove the params from the url

        this.eGroupBaseUrl = "/egroups";

        this.scrollToTop();
        //fix styling for the scrolling
        document.documentElement.classList.add("fix-scrolling");
        document.body.classList.add("fix-scrolling");

        let isCampusesLoading: boolean = true;
        let isHomePageLoading: boolean = true;

        if (_.isEmpty(this.props.eGroups.eGroupHomeData)) {
            this.props.actions.eGroups.egroupsGetHomeByUrl({
                url: this.props.router.asPath,
                disableCampusCheck:
                    process.env.NEXT_PUBLIC_DISABLE_CAMPUS_SELECTOR === "1",
            });
            isHomePageLoading = false;
        }
        if (_.isEmpty(this.props.main.campuses)) {
            this.props.actions.main.main_get_all_campuses();
        } else {
            isCampusesLoading = false;
        }

        let description = this.props.eGroups.eGroupHomeData
            ? this.props.eGroups.eGroupHomeData.description
            : "";
        let title = this.props.eGroups.eGroupHomeData
            ? this.props.eGroups.eGroupHomeData.title
            : "";
        this.setState({
            description: description ? description! : "",
            title: title ? title! : "",
            campuses:
                this.props.main.campuses.length > 0
                    ? this.props.main.campuses
                    : [],
            isCampusesLoading,
            isLoading: !isHomePageLoading && !isCampusesLoading,
        });

        this.updateWindowDimensions();

        if (process.browser) {
            window.addEventListener(
                "resize",
                _.debounce(this.updateWindowDimensions, 500)
            );
        }

        document.getElementById("root")?.addEventListener("scroll", () => {
            const scrollPos = document.getElementById("root")?.scrollTop || 0;

            const isScollAfterHeader = scrollPos > 90; // when the scroll top is beyond the header and the egroups learn more
            if (isScollAfterHeader !== this.state.isScollAfterHeader) {
                this.setState({ isScollAfterHeader });
            }
        });
    }

    componentDidUpdate(prevProps: Props & WithRouterProps & eGroupRouteProps) {
        const parsedQuerystring = Helpers.getQueryParamsWithoutCampus(
            this.props.router?.query
        );
        if (parsedQuerystring.hide_egroups_link) {
            delete parsedQuerystring.hide_egroups_link;
        }

        if (this.props.selectedCampusSlug !== prevProps.selectedCampusSlug) {
            this.setState({
                currentCampus: this.props.selectedCampusSlug,
            });
        }
        const eGroupRequestArrayIndex = _.findIndex(
            this.props.eGroups.eGroupRequests,
            { requestId: this.eGroupsRequestId }
        );
        const eGroupRequestPaginationArrayIndex = _.findIndex(
            this.props.eGroups.eGroupRequests,
            {
                requestId:
                    this.eGroupListPaginationRequestId +
                    Buffer.from(
                        JSON.stringify(
                            Helpers.getQueryParamsWithoutCampus(
                                this.props.router?.query
                            )
                        ),
                        "base64"
                    ).toString("base64"),
            }
        );

        if (
            eGroupRequestArrayIndex > -1 &&
            this.props.eGroups.eGroupRequests[eGroupRequestArrayIndex] &&
            (!_.isEqual(
                this.props.eGroups.eGroupRequests[eGroupRequestArrayIndex]
                    .egroupsList,
                this.state.eGroupsRaw
            ) ||
                this.props.eGroups.eGroupRequests[eGroupRequestArrayIndex]
                    .successTimestamp !== this.state.successTimestamp)
        ) {
            this.setState({
                eGroupsRaw:
                    this.props.eGroups.eGroupRequests[eGroupRequestArrayIndex]
                        .egroupsList,
                successTimestamp:
                    this.props.eGroups.eGroupRequests[eGroupRequestArrayIndex]
                        .successTimestamp,
                isLoading: false,
                eGroupCount:
                    this.props.eGroups.eGroupRequests[eGroupRequestArrayIndex]
                        .count,
            });

            this.props.actions.eGroups.cleareGroupRequest(
                this.eGroupsRequestId
            );
        }

        if (
            eGroupRequestPaginationArrayIndex > -1 &&
            this.props.eGroups.eGroupRequests[
                eGroupRequestPaginationArrayIndex
            ] &&
            (!_.isEqual(
                this.props.eGroups.eGroupRequests[
                    eGroupRequestPaginationArrayIndex
                ].egroupsList,
                this.state.eGroupsRaw
            ) ||
                this.props.eGroups.eGroupRequests[
                    eGroupRequestPaginationArrayIndex
                ].successTimestamp !== this.state.successTimestamp)
        ) {
            this.setState({
                eGroupsRaw:
                    this.props.eGroups.eGroupRequests[
                        eGroupRequestPaginationArrayIndex
                    ].egroupsList,
                successTimestamp:
                    this.props.eGroups.eGroupRequests[
                        eGroupRequestPaginationArrayIndex
                    ].successTimestamp,
                isLoading: false,
            });

            this.props.actions.eGroups.cleareGroupRequest(
                this.eGroupListPaginationRequestId +
                    Buffer.from(
                        JSON.stringify(
                            Helpers.getQueryParamsWithoutCampus(
                                this.props.router?.query
                            )
                        ),
                        "base64"
                    ).toString("base64")
            );
        }

        if (!_.isEqual(this.props.main.campuses, this.state.campuses)) {
            this.setState(
                {
                    campuses: this.props.main.campuses,
                    isCampusesLoading: false,
                    isLoading: !this.showHome(),
                },
                () => {
                    if (
                        !_.isEmpty(this.state.eGroupHomeData) &&
                        !this.showHome()
                    ) {
                        this.loadeGroups(
                            undefined,
                            undefined,
                            false,
                            undefined,
                            undefined,
                            true
                        );
                    } else if (!_.isEmpty(this.state.eGroupHomeData)) {
                        if (!this.props.eGroups.isLoadingFilters) {
                            this.loadeGroupsFilters(parsedQuerystring);
                        }
                    }
                }
            );
        }

        if (this.props.selectedCampusSlug !== prevProps.selectedCampusSlug) {
            if (
                this.props.selectedCampusSlug &&
                this.validateCampus(this.props.selectedCampusSlug)
            ) {
                document
                    .getElementById("root")
                    ?.classList.remove("no-overflow-y");

                this.setState(
                    {
                        showCampusFilter: false,
                    },
                    () => {
                        if (
                            !_.isEmpty(this.state.campuses) &&
                            !this.showHome()
                        ) {
                            this.loadeGroups(
                                undefined,
                                undefined,
                                false,
                                undefined,
                                this.props.selectedCampusSlug,
                                true
                            );
                        }
                    }
                );
                if (process.browser) {
                    window.scrollTo(0, 0);
                }
            } else {
                this.props.router.push(
                    {
                        pathname:
                            this.state.eGroupHomeData?.url ||
                            this.eGroupBaseUrl,
                        query: Helpers.getQueryParamsWithoutCampus(
                            this.props.router?.query
                        ),
                    },
                    undefined,
                    { shallow: true }
                );
            }
        }

        if (
            !_.isEqual(
                this.state.currentFilters,
                Helpers.getQueryParamsWithoutCampus(this.props.router?.query)
            )
        ) {
            const currentFilterBeingApplied = _.omitBy(
                Object.assign({}, parsedQuerystring),
                (v, k: string) => {
                    return (
                        this.state.currentFilters &&
                        _.isEqual(this.state.currentFilters[k], v)
                    );
                }
            );
            let currentFilterBeingAppliedName: string[] = [];

            if (currentFilterBeingApplied) {
                const currentFilterBeingAppliedKeys = Object.keys(
                    currentFilterBeingApplied
                );

                currentFilterBeingAppliedName = currentFilterBeingAppliedKeys;
            }
            this.setState({
                currentFilters: Helpers.getQueryParamsWithoutCampus(
                    this.props.router?.query
                ),
                // isLoading: !_.isEmpty(parsedQuerystring),
            });

            if (this.state.eGroupHomeData) {
                this.loadFilters(() => {
                    if (this.state.eGroupHomeData) {
                        if (
                            !_.isEmpty(this.state.campuses) &&
                            !this.showHome()
                        ) {
                            this.loadeGroups(
                                undefined,
                                undefined,
                                false,
                                undefined,
                                undefined,
                                true,
                                currentFilterBeingAppliedName
                            );
                        } else if (!_.isEmpty(this.state.campuses)) {
                            if (!this.props.eGroups.isLoadingFilters) {
                                this.loadeGroupsFilters(
                                    parsedQuerystring,
                                    true,
                                    undefined,
                                    currentFilterBeingAppliedName
                                );
                            }
                        }
                    }
                });
            }
        }

        if (
            !_.isEqual(
                this.props.eGroups.eGroupHomeData,
                this.state.eGroupHomeData
            ) ||
            this.props.eGroups.eGroupHomeData?.loadTime !==
                this.state.eGroupHomeData?.loadTime
        ) {
            if (!this.props.eGroups.eGroupHomeData?.loadError) {
                const expandedFilters = this.helpers.getExpandedFilters(
                    this.props.eGroups.eGroupHomeData,
                    Helpers.getQueryParamsWithoutCampus(
                        this.props.router?.query
                    )
                );
                this.setState(
                    {
                        eGroupHomeData: this.props.eGroups.eGroupHomeData,
                        homepageLoaded: true,
                        expandedFilters:
                            this.state.window.width >
                            this.props.main.desktopMinSize - 1
                                ? expandedFilters
                                : [],
                    },
                    () => {
                        if (!this.props.eGroups.isLoadingFilters) {
                            let currentFilterBeingAppliedName: string[] = [];

                            if (parsedQuerystring) {
                                const currentFilterBeingAppliedKeys =
                                    Object.keys(parsedQuerystring);

                                currentFilterBeingAppliedName =
                                    currentFilterBeingAppliedKeys;
                            }

                            this.loadeGroupsFilters(
                                parsedQuerystring,
                                true,
                                undefined,
                                currentFilterBeingAppliedName
                            );
                        }
                    }
                );
            } else {
                this.setState({
                    show404: true,
                    eGroupHomeData: this.props.eGroups.eGroupHomeData,
                });
            }
        }

        if (
            this.props.eGroups.eGroupFilters &&
            this.state.eGroupHomeData &&
            !_.isEqual(
                this.props.eGroups.eGroupFilters,
                this.state.eGroupFiltersValuesRaw
            )
        ) {
            this.setState(
                {
                    eGroupFiltersValues: this.helpers.mapFilterValues(
                        this.props.eGroups.eGroupFilters,
                        this.state.eGroupHomeData
                    ),
                    eGroupFiltersValuesRaw: this.props.eGroups.eGroupFilters,
                    isLoading: false,
                },
                () => {
                    const loadeGroups = () => {
                        if (!this.showHome()) {
                            let currentFilterBeingAppliedName: string[] = [];

                            if (parsedQuerystring) {
                                const currentFilterBeingAppliedKeys =
                                    Object.keys(parsedQuerystring);

                                currentFilterBeingAppliedName =
                                    currentFilterBeingAppliedKeys;
                            }

                            this.loadeGroups(
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                currentFilterBeingAppliedName
                            );
                        }
                    };
                    if (!this.state.filtersLoaded) {
                        this.loadFilters(loadeGroups);
                    }
                }
            );
        }
    }

    componentWillUnmount() {
        if (process.browser) {
            window.removeEventListener("resize", this.updateWindowDimensions);
        }
    }

    updateWindowDimensions = () => {
        if (process.browser) {
            this.setState({
                window: {
                    width: window.innerWidth,
                    height: window.innerHeight,
                },
            });
        }
    };

    scrollToTop = () => {
        this._scrollToRef(this.pageRef);
    };

    _scrollToRef = (parent: React.RefObject<HTMLDivElement>) => {
        const scrollUp = () => {
            if (parent && parent.current) {
                parent.current.scrollIntoView();
            }
        };

        scrollUp();
        setTimeout(scrollUp, 200);
    };

    loadFilters = (callback?: Function) => {
        const parsedQuerystring = Helpers.getQueryParamsWithoutCampus(
            this.props.router?.query
        );

        const blockedCampus: string[] = [];
        const expandedFilters: string[] = [];
        const selectedFilters: ObjectLiteral[] = [];

        // if (this.props.match.params && this.props.selectedCampusSlug) {
        //     const validCampus = this.validateCampus(
        //         this.props.selectedCampusSlug
        //     );

        //     if (!validCampus) {
        //         this.props.router.push({
        //             pathname:
        //                 this.state.eGroupHomeData?.url || this.eGroupBaseUrl,
        //             query: parsedQuerystring,
        //         });
        //     }
        // }

        if (parsedQuerystring && this.props.eGroups.eGroupHomeData) {
            //backwards compatibility
            if (parsedQuerystring.study) {
                const topic = parsedQuerystring.study;

                delete parsedQuerystring.category;
                delete parsedQuerystring.study;
                parsedQuerystring.topic = topic;

                if (topic) {
                    selectedFilters.push({
                        name: this.helpers.topicFilterName,
                        content: [topic],
                    });
                }
                this.props.router.push(
                    {
                        pathname: this.props.router.asPath,
                        query: parsedQuerystring,
                    },
                    undefined,
                    { shallow: true }
                );
            }

            if (parsedQuerystring.category) {
                delete parsedQuerystring.category;
                this.props.router.push(
                    {
                        pathname: this.props.router.asPath,
                        query: parsedQuerystring,
                    },
                    undefined,
                    { shallow: true }
                );
            }

            if (
                parsedQuerystring.campus &&
                !_.isArray(parsedQuerystring.campus)
            ) {
                if (this.validateCampus(parsedQuerystring.campus)) {
                    selectedFilters.push({
                        name: this.helpers.campusFilterName,
                        content: [parsedQuerystring.campus],
                    });
                }
            } else if (
                parsedQuerystring.campus &&
                _.isArray(parsedQuerystring.campus)
            ) {
                const campusSelected: string[] = [];
                parsedQuerystring.campus.forEach((campus) => {
                    if (this.validateCampus(campus)) {
                        campusSelected.push(campus);
                    }
                });

                selectedFilters.push({
                    name: this.helpers.campusFilterName,
                    content: campusSelected,
                });
            }

            this.props.eGroups.eGroupHomeData.templateFilters?.forEach(
                (filter) => {
                    if (filter.name !== this.helpers.campusFilterName) {
                        const existIndex = _.findIndex(selectedFilters, {
                            name: filter.name,
                        });

                        if (
                            parsedQuerystring[filter.name] &&
                            !_.isArray(parsedQuerystring[filter.name])
                        ) {
                            if (existIndex > -1) {
                                selectedFilters[existIndex].content = [
                                    ...selectedFilters[existIndex].content,
                                    parsedQuerystring[filter.name],
                                ];
                            } else {
                                selectedFilters.push({
                                    name: filter.name,
                                    content: [parsedQuerystring[filter.name]],
                                });
                            }
                        } else if (
                            parsedQuerystring[filter.name] &&
                            _.isArray(parsedQuerystring[filter.name])
                        ) {
                            const filterValues: string[] = [];
                            (
                                parsedQuerystring[filter.name] as string[]
                            ).forEach((element) => {
                                filterValues.push(element);
                            });

                            if (existIndex > -1) {
                                selectedFilters[existIndex].content = [
                                    ...selectedFilters[existIndex].content,
                                    ...filterValues,
                                ];
                            } else {
                                selectedFilters.push({
                                    name: filter.name,
                                    content: filterValues,
                                });
                            }
                        }
                    }
                }
            );
        }

        if (parsedQuerystring.egroup_name) {
            selectedFilters.push({
                name: "egroup_name",
                content: [parsedQuerystring.egroup_name as string],
            });
        }

        if (parsedQuerystring.egroup_region) {
            selectedFilters.push({
                name: "egroup_region",
                content: [parsedQuerystring.egroup_region as string],
            });
        }

        this.setState(
            {
                selectedFilters,
                expandedFilters:
                    this.state.window.width > this.props.main.desktopMinSize - 1
                        ? expandedFilters
                        : [], // if mobile there's no need to open the filters by default
                filtersLoaded: true,
                blockedCampus,
                currentFilters: parsedQuerystring,
            },
            () => {
                if (_.isFunction(callback)) {
                    callback();
                }
            }
        );
    };

    validateCampus = (campusSlug: string) => {
        let found = false;
        this.props.main.campuses.forEach((campus) => {
            if (
                campusSlug &&
                campus.slugName.toLowerCase() === campusSlug.toLowerCase()
            ) {
                found = true;
            }
        });

        return found;
    };

    showHome = () => {
        return this.state.selectedFilters.length === 0;
    };

    loadeGroups = (
        parsedQuerystringSource?: ParsedUrlQuery,
        extraPaginationQuery?: ObjectLiteral,
        addBlockedCampuses: boolean = true,
        requestId = this.eGroupsRequestId,
        campusToSend = this.props.selectedCampusSlug,
        loadFilters: boolean = false,
        currentFilterBeingApplied?: string[]
    ) => {
        let paginationQuery = this.eGroupPaginationQuery;
        let parsedQuerystring = parsedQuerystringSource;

        if (extraPaginationQuery) {
            paginationQuery = {
                ...paginationQuery,
                ...extraPaginationQuery,
            };
        }

        if (!parsedQuerystring) {
            parsedQuerystring = Helpers.getQueryParamsWithoutCampus(
                this.props.router?.query
            );
        }

        if (campusToSend) {
            if (parsedQuerystring.campus) {
                const index = _.indexOf(parsedQuerystring.campus, campusToSend);
                let newArrayCampus: string[] = [];

                if (index > -1) {
                    newArrayCampus = parsedQuerystring.campus as string[];
                } else {
                    newArrayCampus = [campusToSend];
                }
                parsedQuerystring.campus = newArrayCampus;
            } else {
                parsedQuerystring.campus = campusToSend;
            }
        }

        let defaultQuery;

        if (this.props.eGroups.eGroupHomeData?.requiredQuery) {
            defaultQuery = this.props.eGroups.eGroupHomeData?.requiredQuery;
        }
        const apiReadyQuery = this.helpers.getAPIReadyQuery(
            this.state.eGroupHomeData,
            parsedQuerystring,
            addBlockedCampuses,
            loadFilters,
            this.props.main.campuses,
            paginationQuery,
            this.state.blockedCampus,
            defaultQuery,
            currentFilterBeingApplied
        );

        this.props.actions.eGroups.egroupsGetEgroups({
            querystring: apiReadyQuery,
            requestId: requestId,
            loadFilters,
        });
    };

    loadeGroupsFilters = (
        parsedQuerystringSource?: ParsedUrlQuery,
        addBlockedCampuses: boolean = true,
        campusToSend = this.props.router?.query.campus &&
            this.props.router?.query.campus[
                this.props.router?.query.campus.length - 1
            ],
        currentFilterBeingApplied?: string[]
    ) => {
        let parsedQuerystring = parsedQuerystringSource;
        if (!parsedQuerystring) {
            parsedQuerystring = Helpers.getQueryParamsWithoutCampus(
                this.props.router?.query
            );
        }

        if (parsedQuerystring.campusSelector) {
            this.onClickCampusCommunityCard();
        }

        if (campusToSend) {
            if (parsedQuerystring.campus) {
                const index = _.indexOf(parsedQuerystring.campus, campusToSend);
                let newArrayCampus: string[] = [];

                if (index > -1) {
                    newArrayCampus = parsedQuerystring.campus as string[];
                } else {
                    newArrayCampus = [campusToSend];
                }
                parsedQuerystring.campus = newArrayCampus;
            } else {
                parsedQuerystring.campus = campusToSend;
            }
        }
        let defaultQuery;
        if (this.state.eGroupHomeData?.requiredQuery) {
            defaultQuery = this.state.eGroupHomeData?.requiredQuery;
        }
        const apiReadyQuery = this.helpers.getAPIReadyQuery(
            this.state.eGroupHomeData,
            parsedQuerystring,
            addBlockedCampuses,
            true,
            this.props.main.campuses,
            undefined,
            this.state.blockedCampus,
            defaultQuery,
            currentFilterBeingApplied
        );
        this.props.actions.eGroups.egroupsGetEgroupsFilters({
            querystring: apiReadyQuery,
        });
    };

    clearExpandedFilters = (name?: string) => {
        let expandedFilters: string[] = [];

        if (name) {
            expandedFilters = _.without(
                this.state.expandedFilters.slice(0),
                name
            );
        }

        this.setState({
            expandedFilters,
        });
    };

    changeFilter = (name: string, content: string) => {
        if (this.state.isLoading) return;

        let campus =
            this.props.router?.query.campus &&
            this.props.router?.query.campus[
                this.props.router?.query.campus.length - 1
            ];

        const parentIndex = _.findIndex(this.state.selectedFilters, { name });
        let index = -1;

        if (parentIndex > -1) {
            index = _.indexOf(
                this.state.selectedFilters[parentIndex].content,
                content
            );
        }

        let newSelectedFilters: ObjectLiteral[] = [];

        if (index > -1) {
            newSelectedFilters = this.state.selectedFilters.slice(0);
            newSelectedFilters[parentIndex].content.splice(index, 1);

            if (newSelectedFilters[parentIndex].content.length === 0) {
                newSelectedFilters.splice(parentIndex, 1);
            }
        } else {
            if (parentIndex > -1) {
                newSelectedFilters = this.state.selectedFilters.slice(0);
                newSelectedFilters[parentIndex].content.push(content);
            } else {
                newSelectedFilters = [
                    ...this.state.selectedFilters,
                    { name, content: [content] },
                ];
            }
        }

        const parsedQuerystring = Helpers.getQueryParamsWithoutCampus(
            this.props.router?.query
        );

        if (name === this.helpers.campusFilterName) {
            campus = content;

            newSelectedFilters = this.state.selectedFilters;
            delete parsedQuerystring.campusSelector;
        } else {
            if (
                parsedQuerystring &&
                parsedQuerystring[name] &&
                _.isArray(parsedQuerystring[name])
            ) {
                const indexQueryString = _.indexOf(
                    parsedQuerystring[name],
                    content
                );

                if (indexQueryString > -1) {
                    (parsedQuerystring[name] as any[]).splice(
                        indexQueryString,
                        1
                    );
                } else {
                    (parsedQuerystring[name] as any[]).push(content);
                }
            } else if (parsedQuerystring[name] === content) {
                delete parsedQuerystring[name];
            } else if (parsedQuerystring[name]) {
                const oldContent: string[] = (
                    _.isArray(parsedQuerystring[name])
                        ? parsedQuerystring[name]
                        : [parsedQuerystring[name]]
                ) as string[];

                parsedQuerystring[name] = [...oldContent, content];
            } else {
                parsedQuerystring[name] = content;
            }
        }

        this.setState(
            {
                selectedFilters: newSelectedFilters,
                isLoading: true,
                currentCampus: campus,
            },
            () => {
                this.afterFilterChange(parsedQuerystring, false, campus);
            }
        );
    };

    clearFilter = (name: string) => {
        const parsedQuerystring = Helpers.getQueryParamsWithoutCampus(
            this.props.router?.query
        );
        delete parsedQuerystring[name];
        let url = "";
        for (const [key, value] of Object.entries(parsedQuerystring)) {
            if (parsedQuerystring.campus && key === "campus") {
                url.concat("/" + value);
            }
            if (key !== name) {
                url.concat(`&${key}=${value}`);
            }
        }

        let campusToUse = this.props.router?.query.campus
            ? this.props.router?.query.campus[
                  this.props.router?.query.campus.length - 1
              ]
            : "";

        if (name === this.helpers.campusFilterName && window != undefined) {
            // const currentURL = this.props.router.asPath.split("?")[0];
            const currentURL = window.location.pathname;
            url = currentURL.replace(
                this.props.router?.query.campus[
                    this.props.router?.query?.campus?.length - 1
                ],
                ""
            );
            campusToUse = "";
        }

        let finalQuery = {};
        if (campusToUse) {
            finalQuery = { campus: campusToUse, ...parsedQuerystring };
        } else {
            finalQuery = parsedQuerystring;
        }

        this.props.router.push(
            {
                pathname: url,
                query: _.cloneDeep(finalQuery),
            },
            undefined,
            { shallow: true }
        );

        const selectedFilters = this.state.selectedFilters.slice(0);

        const filterPos = _.findIndex(selectedFilters, { name });

        if (filterPos > -1) {
            selectedFilters.splice(filterPos, 1);
        }

        this.setState(
            {
                selectedFilters,
                currentCampus: campusToUse,
            },
            () => {
                this.loadeGroupsFilters(parsedQuerystring, false, campusToUse);
            }
        );
    };

    onClickCampusCommunityCard = () => {
        if (this.state.window.width < this.props.main.desktopMinSize) {
            let expandedFilters = this.state.expandedFilters;

            if (!expandedFilters.includes(this.helpers.campusFilterName)) {
                expandedFilters.push(this.helpers.campusFilterName);
            }

            this.setState({
                expandedFilters,
            });
        } else {
            if (document.getElementById("root")) {
                document.getElementById("root")?.classList.add("no-overflow-y");
                document.getElementById("root")!.scrollTop = 0;
            }

            this.setState({
                showCampusFilter: true,
            });
        }
    };

    closeCampusFilter = () => {
        const parsedQuerystring = this.props.router.query;

        delete parsedQuerystring.campusSelector;

        if (document.getElementById("root")) {
            document.getElementById("root")?.classList.remove("no-overflow-y");
            document.getElementById("root")!.scrollTop = 0;
        }

        // this.props.history.push({
        //     search: queryString.stringify(parsedQuerystring),
        // });

        this.props.router.push(
            {
                query: parsedQuerystring,
            },
            undefined,
            { shallow: true }
        );

        this.setState({
            showCampusFilter: false,
        });
    };

    serialize = function (obj: any) {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(
                    encodeURIComponent(p) + "=" + encodeURIComponent(obj[p])
                );
            }
        return str.join("&");
    };

    afterFilterChange = (
        parsedQuerystring: ParsedUrlQuery,
        extraCheckToLoadeGroups = true,
        campus = this.props.selectedCampusSlug
    ) => {
        let historyLocation =
            this.state.eGroupHomeData?.url || this.eGroupBaseUrl;
        this.scrollToTop();

        if (campus) {
            historyLocation += "/" + campus;
        }

        let processedParam = [];

        for (const [key, value] of Object.entries(parsedQuerystring)) {
            if (key != "campus") {
                if (_.isArray(value)) {
                    for (const item of value) {
                        processedParam.push(
                            `${key}=${encodeURIComponent(item)}`
                        );
                    }
                } else {
                    processedParam.push(`${key}=${encodeURIComponent(value)}`);
                }
            }
        }
        let processParamString = processedParam.join("&");

        let finalUrlWithParams = "";
        if (processParamString) {
            finalUrlWithParams = `${historyLocation}?${processParamString}`;
        } else {
            finalUrlWithParams = historyLocation;
        }

        this.props.router.push(finalUrlWithParams, undefined, {
            shallow: true,
        });
        // this.props.router.push({
        //     pathname: historyLocation,
        //     query: parsedQuerystring,
        // });

        if (extraCheckToLoadeGroups && !this.showHome()) {
            this.loadeGroups(
                parsedQuerystring,
                {},
                undefined,
                undefined,
                campus
            );
        } else if (this.showHome()) {
            if (!this.props.eGroups.isLoadingFilters) {
                this.loadeGroupsFilters(parsedQuerystring, false, campus);
            }
            this.setState({
                isLoading: false,
            });
        }
    };

    getCampusName = (campusSlug: string) => {
        let campusName = "";

        this.props.main.campuses.forEach((campus) => {
            if (campus.slugName === campusSlug) {
                if (campus.slugName === "winston-salem") {
                    campusName = "Winston-Salem";
                    return;
                }
                campusName = campus.name;
            }
        });

        return campusName;
    };

    renderLoading = () => {
        // show loading depending on the potential content
        const parsedQuerystring = Helpers.getQueryParamsWithoutCampus(
            this.props.router?.query
        );

        if (
            parsedQuerystring.demographic ||
            parsedQuerystring.day ||
            parsedQuerystring.topic ||
            parsedQuerystring.meetingtype ||
            parsedQuerystring.childcare ||
            parsedQuerystring.campus
        ) {
            return this.renderListLoading();
        } else {
            return this.renderHomeLoading();
        }
    };

    renderHome = () => {
        if (
            this.state.isLoading ||
            this.state.isCampusesLoading ||
            this.state.isDemographicLoading ||
            this.state.iseGroupTypesLoading
        ) {
            return this.renderHomeLoading();
        }

        const selectedCampus = this.helpers.getQueryCampusValue(
            this.state.currentCampus,
            this.props.main.campuses
        );

        return (
            <div>
                {this.props.eGroups.eGroupHomeData &&
                    _.orderBy(
                        this.props.eGroups.eGroupHomeData.templateSections,
                        "order"
                    ).map((eGroupSection, key) => (
                        <HomeSection
                            key={key}
                            eGroupSection={eGroupSection}
                            selectedCampus={
                                this.state.currentCampus
                                    ? {
                                          id: selectedCampus
                                              ? selectedCampus.id
                                              : "",
                                          name: selectedCampus
                                              ? selectedCampus.slugName
                                              : "",
                                      }
                                    : null
                            }
                            {...this.props}
                        />
                    ))}
            </div>
        );
    };

    renderHomeLoading = () => {
        return (
            <div className="m-t-spacer-md flex flex-column p-x-spacer-sm mob-p-x-spacer-md">
                <div className="text-alt-dark-grey half-width animate-shimmer m-b-spacer-sm element-loading-shimmer" />
                <div className="flex flex-row flex-wrap m-b-spacer-md">
                    <div className="text-alt-dark-grey animate-shimmer ec-border-radius m-r-spacer-md m-y-spacer-md egroups-home-loading-element flex-two-column" />
                    <div className="text-alt-dark-grey animate-shimmer ec-border-radius m-r-spacer-md m-y-spacer-md egroups-home-loading-element flex-two-column" />
                </div>

                <div className="text-alt-dark-grey half-width animate-shimmer m-b-spacer-sm element-loading-shimmer" />
                <div className="flex flex-row flex-wrap">
                    <div className="text-alt-dark-grey animate-shimmer ec-border-radius m-r-spacer-md m-y-spacer-md egroups-home-loading-element flex-two-column" />
                    <div className="text-alt-dark-grey animate-shimmer ec-border-radius m-r-spacer-md m-y-spacer-md egroups-home-loading-element flex-two-column" />
                </div>
            </div>
        );
    };

    renderListLoading = () => {
        const content: JSX.Element[] = [];
        for (let i = 0; i < parseInt(this.eGroupToShow); i++) {
            content.push(<GroupListItemLoading key={i} />);
        }

        return (
            <div id="list" className="m-t-spacer-md">
                {content}
            </div>
        );
    };

    renderList = () => {
        const indexRequestLoading = _.findIndex(
            this.props.eGroups.isLoadingEgroups,
            { requestId: this.eGroupsRequestId }
        );

        return (
            <div className="m-t-spacer-md">
                <GroupsList
                    eGroupsList={this.state.eGroupsRaw}
                    eGroupCount={this.state.eGroupCount}
                    eGroupRequestSuccessTimestamp={this.state.successTimestamp}
                    isLoading={
                        this.state.isLoading ||
                        this.state.isDemographicLoading ||
                        this.state.iseGroupTypesLoading ||
                        (this.props.eGroups.isLoadingEgroups[
                            indexRequestLoading
                        ] &&
                            this.props.eGroups.isLoadingEgroups[
                                indexRequestLoading
                            ].isLoading)
                    }
                    itemsToShow={parseInt(this.eGroupToShow)}
                    eGroupQuery={Helpers.getQueryParamsWithoutCampus(
                        this.props.router?.query
                    )}
                    requestId={this.eGroupsRequestId}
                    loadeGroups={this.loadeGroups}
                    pageSize={parseInt(this.eGroupToShow)}
                    renderListLoading={this.renderListLoading}
                    eGroupListPaginationRequestId={
                        this.eGroupListPaginationRequestId +
                        Buffer.from(
                            JSON.stringify(
                                Helpers.getQueryParamsWithoutCampus(
                                    this.props.router?.query
                                )
                            ),
                            "base64"
                        ).toString("base64")
                        // btoa(
                        //     JSON.stringify(
                        //         Helpers.getQueryParamsWithoutCampus(
                        //             this.props.router?.query
                        //         )
                        //     )
                        // )
                    }
                    currentFilters={{
                        ...this.state.currentFilters,
                        campus: this.state.currentCampus,
                    }}
                    {...this.props}
                />
            </div>
        );
    };

    getCurrentUrl = () => {
        let url = "/egroups/map";

        if (this.props.selectedCampusSlug) {
            url += "/" + this.props.selectedCampusSlug;
        }

        const parsedQuerystring = Helpers.getQueryParamsWithoutCampus(
            this.props.router?.query
        );

        return queryString.stringifyUrl({ url, query: parsedQuerystring });
    };

    renderFilters = () => {
        const indexRequestLoading = _.findIndex(
            this.props.eGroups.isLoadingEgroups,
            { requestId: "eGroupList" }
        );

        if (this.state.showCampusFilter) {
            return (
                <CampusFilter
                    selectedCampus={this.props.selectedCampusSlug}
                    changeCampus={this.changeFilter}
                    blockedCampus={this.state.blockedCampus}
                    closeCampusFilter={this.closeCampusFilter}
                    {...this.props}
                />
            );
        } else {
            const selectedFilterToSend = [...this.state.selectedFilters];
            if (
                this.props.selectedCampusSlug &&
                this.validateCampus(this.props.selectedCampusSlug)
            ) {
                selectedFilterToSend.push({
                    name: this.helpers.campusFilterName,
                    content: [this.props.selectedCampusSlug],
                });
            }

            return (
                <Filters
                    windowDimensions={this.state.window}
                    isScollAfterHeader={this.state.isScollAfterHeader}
                    changeFunction={this.changeFilter}
                    clearFunction={this.clearFilter}
                    selectedFilters={selectedFilterToSend}
                    eGroupFiltersValues={this.state.eGroupFiltersValues}
                    expandedFilters={this.state.expandedFilters}
                    isLoaded={
                        this.state.filtersLoaded &&
                        this.state.homepageLoaded &&
                        !!this.state.eGroupFiltersValues
                    }
                    isLoading={
                        this.state.isLoading ||
                        this.state.isDemographicLoading ||
                        this.state.iseGroupTypesLoading ||
                        !this.state.homepageLoaded ||
                        this.props.eGroups.isLoadingFilters ||
                        (this.props.eGroups.isLoadingEgroups[
                            indexRequestLoading
                        ] &&
                            this.props.eGroups.isLoadingEgroups[
                                indexRequestLoading
                            ].isLoading)
                    }
                    clearFilters={this.clearExpandedFilters}
                    mobileRedirectToOtherViewIcon={faMapMarkedAlt}
                    mobileRedirectToOtherViewUrl={this.getCurrentUrl()}
                    mobileRedirectToOtherViewTitle="Map View"
                    {...this.props}
                />
            );
        }
    };

    render() {
        if (this.state.show404) {
            return <Error404 />;
        }

        const parsedQuerystring = Helpers.getQueryParamsWithoutCampus(
            this.props.router?.query
        );
        const showHome = this.showHome();
        let content = this.renderLoading();
        let campusText = "a ";
        let showingRealContent = false;

        if (this.state.filtersLoaded && showHome && this.state.homepageLoaded) {
            content = this.renderHome();
            showingRealContent = true;
        } else if (this.state.filtersLoaded && !showHome) {
            content = this.renderList();
            showingRealContent = true;
        }

        if (this.props.selectedCampusSlug) {
            const campusName = this.props.selectedCampusSlug;
            const matched = campusName.match("^[aieouAIEOU].*");

            if (matched && campusName !== "university-city") {
                campusText = "an " + this.getCampusName(campusName);
            } else {
                campusText = "a " + this.getCampusName(campusName);
            }
        }

        let description = this.state.description;
        if (description) {
            description = description.replace(":campus", campusText);
        }

        return (
            <div ref={this.pageRef}>
                {parsedQuerystring &&
                parsedQuerystring.hide_egroups_link ? null : (
                    <a
                        className="egroups-link flex flex-align-center flex-justify-center full-width mob-flex-justify-between mob-p-l-spacer-md mob-p-r-spacer-sm p-x-spacer-lg p-y-spacer-md text-white"
                        href="https://elevationchurch.org/egroups"
                        id={`"cc-egroups${
                            this.props.eGroups.eGroupHomeData.name
                                ? `-${this.props.eGroups.eGroupHomeData.name.toLowerCase()}`
                                : ""
                        }-${this.props.selectedCampusSlug}-find-learn-more`}
                    >
                        <span className="m-r-spacer-sm mob-m-r-spacer-none regular">
                            Learn more about eGroups
                        </span>
                        <FontAwesomeIcon
                            icon={faChevronRight}
                            className="text-white xsmall-link mob-font-size-12"
                            aria-hidden="true"
                        />
                    </a>
                )}
                <div className="egroups">
                    <div
                        className={classnames("egroups-home container ", {
                            "no-scroll": this.state.showCampusFilter,
                            "minus-hide-egroups-link":
                                !parsedQuerystring ||
                                !parsedQuerystring.hide_egroups_link,
                        })}
                    >
                        <div
                            className={classnames(
                                "flex flex-align-start flex-wrap",
                                {
                                    "no-overflow full-height":
                                        this.state.showCampusFilter,
                                }
                            )}
                        >
                            {this.state.window.width >
                            this.props.main.desktopMinSize - 1
                                ? this.renderFilters()
                                : ""}

                            <div className="content fullPercentWidth mob-p-y-spacer-xl mob-p-y-spacer-xl rel-pos">
                                <div className="filterContainer">
                                    <ConditionalWrapper
                                        condition={
                                            this.state.window.width <
                                            this.props.main.desktopMinSize
                                        }
                                        wrapper={(
                                            children:
                                                | JSX.Element[]
                                                | JSX.Element
                                        ) => (
                                            <div className="mob-p-l-spacer-md">
                                                {children}
                                            </div>
                                        )}
                                    >
                                        <h1 className="m-y-spacer-none font-size-40 ln-height-reset">
                                            {this.state.title}
                                        </h1>
                                        <h2 className="m-t-spacer-none m-b-spacer-md font-size-18 prim-font ec-text-grey regular">
                                            {description}
                                        </h2>
                                    </ConditionalWrapper>
                                    {this.state.window.width <
                                    this.props.main.desktopMinSize
                                        ? this.renderFilters()
                                        : ""}
                                </div>
                                <hr className="b-b-width-xs b-width-none border-off-white full-width desktop-hide m-b-spacer-md" />

                                {/* {!this.props.router?.query.campus &&
                                showingRealContent ? (
                                    <Intro
                                        handleCampusClick={
                                            this.onClickCampusCommunityCard
                                        }
                                        {...this.props}
                                    />
                                ) : (
                                    ""
                                )} */}
                                {content}
                            </div>
                            {this.state.showCampusFilter ? (
                                <div
                                    className="whole-page-overlay fade-in"
                                    onClick={() => {
                                        this.clearFilter(
                                            this.helpers.campusFilterName
                                        );
                                    }}
                                />
                            ) : (
                                ""
                            )}
                        </div>
                        {this.state.showCampusFilter ? (
                            <div
                                className="whole-page-overlay fade-in"
                                onClick={() => {
                                    this.clearFilter(
                                        this.helpers.campusFilterName
                                    );
                                }}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(eGroupsHome));
